import StoreForm, { MockUpForm } from "@components/PurchaseForms";
import StoreLayout from "@components/StoreLayout";
import PurchaseComplete from "@pages/PurchaseComplete";
import Licenses from "@pages/Licenses";
import Accessories from "@pages/Accessories";
import TestAllAPIs from "@pages/TestAllAPIs";
import { Route, Routes, useParams } from "react-router-dom";
import { useEffect } from "react";
import { getMockupData } from "@constants/mockup/mockupFormDefaults";
import StepForm from "@components/StepForm";
import { useFormContext } from "react-hook-form";

// Wrapper component to extract country ID from route params and apply mockup data
function MockupWithCountry() {
  const { countryId } = useParams();
  const methods = useFormContext();

  useEffect(() => {
    const mockupData = getMockupData(countryId);
    methods.reset(mockupData);
  }, [countryId, methods]);

  return <StepForm />;
}

function App() {
  return (
    <Routes>
      {import.meta.env.MODE === "development" && <Route path="/test" element={<TestAllAPIs />} />}

      <Route element={<StoreLayout />}>
        <Route path="/" element={<StoreForm />} />
        <Route path="/licenses" element={<Licenses />} />
        <Route path="/accessories" element={<Accessories />} />
        {import.meta.env.MODE === "development" && (
          <>
            <Route path="/mockup" element={<MockUpForm />} />
            <Route path="/mockup/:countryId" element={<MockupWithCountry />} />
          </>
        )}
        <Route path="purchase-complete" element={<PurchaseComplete />} />
      </Route>
    </Routes>
  );
}

export default App;
